import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Box } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { PageLayout } from './utils/util';;

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2', // Blue
        },
        secondary: {
            main: '#dc004e', // Pink
        },
    },
});

const ContactPage: React.FC = () => {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [returnEmail, setReturnEmail] = useState('');

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        const mailtoLink = `mailto:davidwallachphotography@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message + "\n\nFrom: " + returnEmail)}`;
        window.location.href = mailtoLink;
    };

    return (
        <ThemeProvider theme={theme}>
            <PageLayout title="Contact Page">
                <Container maxWidth="sm">
                    <Box
                        sx={{
                            marginTop: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Typography component="h1" variant="h5">
                            Contact Me
                        </Typography>
                        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
                            <TextField
                                label="Subject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                fullWidth
                                required
                                margin="normal"
                            />
                            <TextField
                                label="Message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                fullWidth
                                required
                                multiline
                                rows={4}
                                margin="normal"
                            />
                            <TextField
                                label="Your Email"
                                value={returnEmail}
                                onChange={(e) => setReturnEmail(e.target.value)}
                                type="email"
                                fullWidth
                                required
                                margin="normal"
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                Send Email
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </PageLayout>
        </ThemeProvider>
    );
};

export default ContactPage;